import {Paper, Typography, Box, Button} from "@mui/material";
import useSWR from "swr";
import {
  swrKey,
  factoringNotificationsFetcher,
} from "components/factoringNotificationsApi.ts";
import useImageUploadDialog from "./ImageUploadDialog";

/**
 * ファクタリング申込に関するお知らせを表示するコンポーネント
 * factoring.notificationがある場合のみお知らせを表示する
 */
export default function FactoringNotification() {
  // ファクタリングデータの取得
  const { data, isLoading, error } = useSWR(
    swrKey,
    factoringNotificationsFetcher,
  );

  // Use the image upload dialog hook
  const { openImageUploadDialog, renderImageUploadDialog } = useImageUploadDialog();

  // Handle image upload button click
  const handleImageUpload = (factoringId: string, applicationNumber: string) => {
    openImageUploadDialog(factoringId, applicationNumber);
  };

  if (isLoading) {
    return null;
  }

  if (error) {
    return (
      <Box>
        <Box sx={{ mb: 3 }}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              border: "1px solid #ccc",
              borderRadius: 2,
              color: "error.main",
            }}
          >
            <Typography variant="body1">{error.message}</Typography>
          </Paper>
        </Box>
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <>
      <Box>
        {data.map((notification, index) => (
          <Box key={index} sx={{ mb: 3 }}>
            <Paper
              elevation={0}
              sx={{
                p: 2,
                border: "1px solid #ccc",
                borderRadius: 2,
                backgroundColor: "#fff9c4", // Light yellow background
              }}
            >
              <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  お知らせ
                </Typography>
                <Typography variant="body1" sx={{ml: 1}}>
                {notification.notificationDate}
                </Typography>
              </Box>
              <Typography variant="body1" sx={{mb: 1}}>
                申込番号：{notification.applicationNumber}
              </Typography>
              <Typography variant="body1" sx={{ whiteSpace: "pre-wrap", mb: 1 }}>
                {notification.notification}
              </Typography>
              {notification.requireAdditionalImages &&
                <Button
                  variant="text"
                  size="small"
                  onClick={() =>
                    handleImageUpload(
                      notification.factoringId,
                      notification.applicationNumber,
                    )
                  }
                  sx={{ fontSize: "0.7rem" }}
                >
                  画像アップロード
                </Button>
              }
            </Paper>
          </Box>
        ))}
      </Box>

      {/* Render the image upload dialog */}
      {renderImageUploadDialog()}
    </>
  );
}
